export default {"src":"/_next/static/media/eos.0e3265f5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};